import _omitBy from 'lodash/omitBy';
import _isNil from 'lodash/isNil';

export const removeNil = (data: Record<string, unknown>) =>
  _omitBy(data, _isNil);
